/**
 * @generated SignedSource<<3641fcd39e5630b966bbd1af05cda5bc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ssrLiveContentsPreviewLiveArticle$data = {
  readonly liveContents: ReadonlyArray<{
    readonly authors: ReadonlyArray<{
      readonly name: string;
    } | null | undefined> | null | undefined;
    readonly body: {
      readonly text: string | null | undefined;
    } | null | undefined;
    readonly customTime: number | null | undefined;
    readonly entityUuid: string;
    readonly title: string | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "ssrLiveContentsPreviewLiveArticle";
};
export type ssrLiveContentsPreviewLiveArticle$key = {
  readonly " $data"?: ssrLiveContentsPreviewLiveArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"ssrLiveContentsPreviewLiveArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ssrLiveContentsPreviewLiveArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "LiveContent",
      "kind": "LinkedField",
      "name": "liveContents",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "entityUuid",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Author",
          "kind": "LinkedField",
          "name": "authors",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FormattedValue",
          "kind": "LinkedField",
          "name": "body",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "text",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "LiveArticle",
  "abstractKey": null
};

(node as any).hash = "883f4f278447992937e7ea03b0852fe8";

export default node;
